import { Check, ChevronDown } from 'lucide-react';

import React, { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Workspace } from '@/features/user-settings/types/workspace-types';

import { cn } from '@/lib/utils';

import SimpleDropdown from './SimpleDropdown';

export function WorkspaceSelector({
	workspaces,
	selectedWorkspaceId,
	onWorkspaceSelect,
	className,
	triggerClassName,
	disabled,
}: {
	selectedWorkspaceId: string;
	workspaces: Workspace[];
	onWorkspaceSelect: (workspace: Workspace) => void;
	className?: string;
	triggerClassName?: string;
	disabled?: boolean;
}) {
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const selected = workspaces?.find((item) => item.id === selectedWorkspaceId);

	return (
		<SimpleDropdown
			className={className}
			open={dropdownOpen}
			onOpenChange={setDropdownOpen}
			options={workspaces?.map((workspace) => ({
				label: workspace.name,
				value: workspace.id,
				onClick: () => onWorkspaceSelect(workspace),
				icon:
					selectedWorkspaceId === workspace.id ? (
						<Check className="size-4" />
					) : (
						<div className="size-4" />
					),
			}))}
		>
			<Button
				variant={'outline'}
				size={'sm'}
				className={triggerClassName}
				disabled={disabled}
			>
				<span>{selected?.name || 'Select workspace'}</span>
				{disabled ? null : (
					<ChevronDown
						className={cn('size-3 transition-transform', dropdownOpen && 'rotate-180')}
					/>
				)}
			</Button>
		</SimpleDropdown>
	);
}
